import { useState, useEffect } from 'react';

/* Replacement for useState that automatically persists to localStorage.*/
const useLocalStorage = (key, defaultValue) => {
  const [value, setValue] = useState(() => {
    try {
      const stored = localStorage.getItem(key);
      return stored !== null ? JSON.parse(stored) : defaultValue;
    } catch (e) {
      console.error(`useLocalStorage: failed to load "${key}"`, e);
      return defaultValue;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      console.error(`useLocalStorage: failed to save "${key}"`, e);
    }
  }, [key, value]);

  return [value, setValue];
};

export default useLocalStorage;